import {
  ElInfiniteScroll,
  ElContainer as Container,
  ElAside as Aside,
  ElMain as Main,
  ElButton as Button,
  ElInput as Input,
  ElMessage as Message,
  ElLoading as Loading,
  ElProgress as Progress,
  ElDialog as Dialog,
  ElTooltip as Tooltip,
  ElMessageBox as MessageBox,
  ElForm as Form,
  ElFormItem as FormItem,
  ElTabs as Tabs,
  ElTabPane as TabPane,
  ElCheckbox as Checkbox,
  ElCheckboxGroup as CheckboxGroup,
  ElDivider as divider,
  ElSelect as Select,
  ElImage as Image,
  ElPopover as Popover,
  ElTable as Table,
  ElTableColumn as TableColumn,
  ElOption as Option,
  ElUpload as Upload,
  ElSkeleton as Skeleton,
  ElSkeletonItem as SkeletonItem,
  ElRadio as Radio,
  ElTag as Tag,
  ElRadioGroup as RadioGroup,
  ElSwitch as Switch,
  ElDatePicker as DatePicker,
  ElSlider as Slider,
  ElDropdown as Dropdown,
  ElDropdownMenu as DropdownMenu,
  ElDropdownItem as DropdownItem,
  ElDrawer as Drawer,
  ElCollapse as Collapse,
  ElCollapseItem as CollapseItem
} from 'element-plus'
// import ElementPlus from 'element-plus'
// import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

const elementArr = [
  Tag,
  Container,
  Aside,
  Main,
  Button,
  Input,
  Progress,
  Dialog,
  Tooltip,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Checkbox,
  CheckboxGroup,
  divider,
  Select,
  Popover,
  Table,
  TableColumn,
  Option,
  Image,
  Upload,
  Skeleton,
  SkeletonItem,
  Radio,
  RadioGroup,
  DatePicker,
  Switch,
  DatePicker,
  Slider,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Drawer,
  Collapse,
  CollapseItem
]

const messages = ['success', 'warning', 'info', 'error']

messages.forEach(type => {
  Message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options
      }
      // 默认配置
      if (options.duration === undefined) {
        options.duration = 2500
      }
    }
    options.type = type
    const Ins = Message(options)
    const timer = options.duration === undefined ? 2500 : options.duration
    // 错误触发了 cleartimeout 事件，在这里设置一个关闭事件
    if (timer) {
      setTimeout(() => {
        Ins.close()
      }, timer)
    }
    return Ins
  }
})
function elementConfig(app) {
  elementArr.forEach(item => {
    app.use(item)
  })
  // app.component(CollapseTransition.name, CollapseTransition)

  // 解决[Vue warn]: A plugin must either be a function or an object with an "install" function. ;
  // app.use(Loading.directive)
  app.use(Loading)

  // [想要解决[Vue warn]: Plugin has already been applied to target app.就要注释掉上面那些]();
  // app.use(ElementPlus)
  // 无限滚动的真正按需引入;
  // [Vue3中按需使用v-infinite-scroll（无限滚动）的坑！](https://www.bilibili.com/read/cv16917491/)；
  // console.log(`全量引入ElementPlus时：ElementPlus-->`, ElementPlus) // 这里发现这里注册的并不只是无限滚动的。
  app.use(ElInfiniteScroll)

  app.config.globalProperties.$loading = Loading.service
  app.config.globalProperties.$message = Message
  app.config.globalProperties.$msgbox = MessageBox
  app.config.globalProperties.$alert = MessageBox.alert
  app.config.globalProperties.$confirm = MessageBox.confirm
  app.config.globalProperties.$prompt = MessageBox.prompt
}

export default elementConfig
